var React = require('react');

function BookIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"book-icon"),React.createElement("path",{"d":"M156,0C91.6976,0,41.7,7.92,41.7,7.92V193.362c28.4683-4.8955,69.11-7.962,114.3-7.962,85.6,0,154.9,11,156,24.6V24.9C312,11.1,242.2,0,156,0Z","style":{"fill":"#274043"},"key":1}),React.createElement("circle",{"cx":"169.2135","cy":"94.0851","r":"51.6027","style":{"fill":"#f0625d"},"key":2}),React.createElement("path",{"d":"M41.7,7.92C15.762,12.3608-.1,18.3231-.1,24.9V210H0c.5193-6.42,16.243-12.26,41.7-16.638Z","style":{"fill":"#f5aa28"},"key":3}),React.createElement("path",{"d":"M156,185.4c-85.6,0-154.9,11-156,24.6H312C310.9,196.4,241.6,185.4,156,185.4Z","style":{"fill":"#f0625d"},"key":4})]);
}

BookIcon.defaultProps = {"width":"312","height":"210","viewBox":"0 0 312 210"};

module.exports = BookIcon;

BookIcon.default = BookIcon;
